import React from 'react';
var BoletaEstado = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, width: "19", height: "19", viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M10.25 8.7501L16.4 2.6001", stroke: "var(--icon-primary-light", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M16.9999 5.6V2H13.3999", stroke: "var(--icon-primary-light", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M8.75 2H7.25C3.5 2 2 3.5 2 7.25V11.75C2 15.5 3.5 17 7.25 17H11.75C15.5 17 17 15.5 17 11.75V10.25", stroke: "var(--icon-primary-light", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
};
BoletaEstado.defaultProps = {
    className: '',
};
export default BoletaEstado;
